export default {
  form: {
    title: '【老屋医生】居家修缮报修单',
    welcome: '亲爱的顾客，感谢您选择我们的服务。请填写资料，以便我们了解您的需求，并提供最佳的修缮服务。 谢谢',
    email: 'Email',
    emailPlaceholder: '您的电子邮件',
    name: '姓名',
    namePlaceholder: '您的回答',
    phone: '电话',
    phonePlaceholder: '您的回答',
    address: '地址',
    addressPlaceholder: '您的回答',
    lineId: 'Line ID',
    lineIdHint: '立案后会以LINE ID，加为点数联络人，个人资料 > ID',
    lineIdPlaceholder: '您的回答',
    isUrgent: '是否为紧急情况',
    urgentGeneral: '一般场勘 $300~800',
    urgentEmergency: '紧急场勘 $1200~1500',
    repairType: '修缮类型',
    noRepairItems: '暂无修缮项目',
    repairTypes: {
      water: '水类',
      electric: '电类',
      leak: '漏水',
      comprehensive: '综合',
      equipment: '卫浴设备',
      other: '其他'
    },
    description: '补充说明',
    descriptionPlaceholder: '您的回答',
    images: '图片/视频上传，拍摄方式的图片或视频等资讯',
    howKnow: '如何得知老屋医生',
    howKnowOptions: {
      fate: '缘故',
      referral: '客介',
      line: 'LINE',
      fb: 'FB',
      ad: '广告',
      other: '其他'
    },
    otherPlaceholder: '请说明',
    referrer: '介绍人姓名、店家',
    referrerPlaceholder: '您的回答',
    joinedLine: '加入【老屋医生】了吗？',
    joinedLineHint: '填写完表单后，别忘了在LINE官方帐号上发布通知作业人员＂修缮囉＂！',
    lineAccount: '【老屋医生】LINE官方帐号：',
    yes: '是',
    no: '否',
    submit: '提交',
    clear: '清除表单',
    required: '此栏位为必填',
    invalidEmail: '请输入有效的电子邮件地址',
    invalidPhone: '请输入10位数字的电话号码',
    invalidFileType: '只能上传图片或视频文件',
    imageTooLarge: '图片大小不能超过10MB',
    videoTooLarge: '视频大小不能超过100MB',
    submitSuccess: '预约提交成功！我们会尽快与您联系。',
    submitFailed: '提交失败，请稍后再试。',
    uploadSuccess: '文件上传成功',
    uploadFailed: '文件上传失败',
    imagePreview: '图片预览',
    videoPreview: '视频预览'
  },
  language: {
    zhTW: '繁體中文',
    zhCN: '简体中文'
  },
  navigation: {
    myReservations: '订单查询'
  },
  success: {
    title: '恭喜！预约成功',
    message: '您的维修预约已成功提交，我们会尽快与您联系。请保持电话畅通。',
    reservationId: '预约编号',
    phone: '联系电话',
    createTime: '提交时间',
    viewMyReservations: '查看我的预约',
    backToHome: '返回首页'
  },
  myReservations: {
    title: '我的预约记录',
    subtitle: '请输入您的电话和Email查询预约记录',
    searchBy: '查询方式（电话和Email必填）',
    phonePlaceholder: '请输入电话号码',
    emailPlaceholder: '请输入Email地址',
    enterSearchCriteria: '请输入电话和Email',
    search: '查询',
    reservationId: '预约编号',
    createTime: '提交时间',
    viewDetail: '查看详情',
    noData: '暂无预约记录',
    backToHome: '返回首页',
    detailTitle: '预约详情',
    basicInfo: '基本资讯',
    repairInfo: '维修资讯',
    images: '相关图片',
    searchFailed: '查询失败',
    loadFailed: '载入失败',
    region: '地区',
    sourceInfo: '来源资讯',
    timeInfo: '时间资讯',
    updateTime: '更新时间',
    status: {
      label: '状态',
      PENDING_REVIEW: '待审核',
      PENDING: '待分配门店',
      PENDING_TECHNICIAN: '待分配师傅',
      QUOTED: '已报价',
      PENDING_CUSTOMER_CONFIRM: '待客户确认',
      MATERIAL_PREPARING: '备料中',
      PENDING_CONSTRUCTION: '待施工',
      CONSTRUCTING: '施工中',
      PENDING_ACCEPTANCE: '待验收',
      ACCEPTANCE: '验收中',
      COMPLETED: '已完成',
      CLOSED: '已结案',
      CANCELLED: '已取消'
    },
    caseNo: '案例编号',
    quotationStage: '报价资讯',
    materialStage: '备料资讯',
    constructionStage: '施工资讯',
    acceptanceStage: '验收资讯',
    currentStage: '当前阶段',
    quotedAmount: '报价金额',
    quotationDesc: '报价说明',
    quotationTime: '报价时间',
    totalApprovedAmount: '总批准金额',
    materialName: '材料名称',
    materialPrice: '材料价格',
    prepareTime: '备料时间',
    constructionDate: '施工日期',
    beforeConstruction: '施工前',
    duringConstruction: '施工中',
    afterConstruction: '施工后',
    completionDate: '完成日期',
    chargeAmount: '收费金额',
    paymentMethod: '支付方式',
    collectionAmount: '收款金额',
    customerConfirm: '客户确认',
    customerSignature: '客户签名',
    remark: '备注',
    description: '描述',
    recordTime: '记录时间',
    pendingConfirmNotice: '师傅已提交报价，请确认是否接受此报价',
    confirmQuotation: '确认报价',
    rejectQuotation: '拒绝报价',
    confirmQuotationMessage: '确认接受此报价后，订单将进入备料阶段，是否继续？',
    confirm: '确认',
    cancel: '取消',
    confirmReject: '确认拒绝',
    rejectReason: '拒绝原因',
    rejectReasonPlaceholder: '请输入拒绝报价的原因',
    rejectReasonRequired: '请输入拒绝原因',
    confirmSuccess: '报价确认成功',
    confirmFailed: '报价确认失败',
    rejectSuccess: '报价已拒绝，等待师傅重新报价',
    rejectFailed: '拒绝报价失败',
    reviewSection: '服务评价',
    technicianReview: '师傅对您的评价',
    customerReview: '您对师傅的评价',
    technician: '师傅',
    myReview: '我的评价',
    yourRating: '您的评分',
    yourReview: '您的评价',
    reviewTime: '评价时间',
    noReviewYet: '您尚未对此次服务进行评价',
    writeReview: '撰写评价',
    rating: '评分',
    reviewContent: '评价内容',
    reviewContentPlaceholder: '请分享您对师傅服务的评价（选填）',
    ratingRequired: '请选择评分',
    submitReview: '提交评价',
    reviewSuccess: '评价提交成功，感谢您的反馈',
    reviewFailed: '评价提交失败',
    reviewSubmittedWaiting: '您已提交评价，待师傅评价后即可查看双方评价内容',
    technicianStats: '师傅评价统计',
    avgRating: '平均评分',
    totalReviews: '累计评价',
    reviewCount: '则',
    ratingTexts: {
      1: '非常不满意',
      2: '不满意',
      3: '一般',
      4: '满意',
      5: '非常满意'
    }
  }
}
